import { render } from "./competence-individual.vue?vue&type=template&id=04e5b763"
import script from "./competence-individual.vue?vue&type=script&lang=js"
export * from "./competence-individual.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/applications/competence/competence-individual.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "04e5b763"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('04e5b763', __exports__)) {
    api.reload('04e5b763', __exports__)
  }
  
  module.hot.accept("./competence-individual.vue?vue&type=template&id=04e5b763", () => {
    api.rerender('04e5b763', render)
  })

}


export default __exports__